export const COOKIE_CONSENT_COOKIE_EXPIRATION = 120;

export const REACT_APP_ONETRUST_ID = process.env.REACT_APP_ONETRUST_SCRIPT_ID?.replace(/["';]/g, "");
export const REACT_APP_ONETRUST_SCRIPT_SRC = `https://cdn.cookielaw.org/consent/${REACT_APP_ONETRUST_ID}/otSDKStub.js`;
export const ONETRUST_MANAGE_EXPERIENCE_LINK_TEXT = "Manage online experience";
export const REACT_APP_ONETRUST_SCRIPT_CHARSET = "UTF-8";
export const REACT_APP_ONETRUST_DATA_DOCUMENT_LANGUAGE = "true";
export const ONE_TRUST_COOKIE_NAME = "OptanonConsent";
export const ONE_TRUST_TRACKING_DISABLED = "C0004:0";
export const ONE_TRUST_TRACKING_ENABLED = "C0004:1";
export const REACT_APP_TRACKER_ID = process.env.REACT_APP_TRACKER_ID?.replace(/["';]/g, "");
export const GA_HOME = "/";
export const GA_QUERIES = "/reporting/queries";
export const GA_QUERIES_PANEL = "/reporting/QueriesPanel";
export const GA_REPORTS = "/reporting";
export const GA_WIRES = "/asset-transfers/wires";
export const GA_WIRES_ADMIN = "/asset-transfers/wires/admin";
export const GA_ASSETTRANSFER_ENTRY = "/asset-transfers/asset-transfer-entry-panel";
export const GA_TRADECAPTURE_LIST = "/trading/list";
export const GA_TRADECAPTURE_ENTRY = "/trading/trade-entry-panel";
export const GA_TRADECAPTURE_UPLOAD = "/trading/upload";
export const GA_TRADECAPTURE_BREAKS = "/trading/breaks";
export const GA_MMF = "/disclaimer/MMF";
export const GA_SHORTSALE_APPROVAL_PERSIST_DETAILS = "/shortsale-approval-persist-details";
export const GA_SHORTSALE_APPROVAL_HISTORY = "/shortsale-approval-history";
export const GA_SHORTSALE_APPROVAL_LOCATE = "/shortsale-approval-locate";
export const GA_SHORTSALE_APPROVAL_UPLOAD = "/shortsale-approval-upload";
export const GA_SHORTSALE_APPROVAL_SEARCH = "/shortsale-approval-search"
export const GA_SHORTSALE_APPROVAL_PASTE_FROM_CLIPBOARD = "/shortsale-approval-paste-from-clipboard"
export const GA_PROFILE = "/Profile/ProfilePanel";
export const GA_CHANGE_PASSWORD = "/Profile/ChangePasswordPanel";
export const GA_CHANGE_PASSWORD_SUCCESS = "/Profile/PasswordResetSuccess";
export const GA_LOGIN = '/login';
export const GA_LOGOUT = '/logout';
export const GA_UNKNOWN = '/unknown';